var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.bodyContent),function(content){return _c('div',{key:content.id,staticClass:"accordion-plain-content"},[_c('span',[_vm._v(_vm._s(content.note))]),_c('span',{staticClass:"plain-content-link"},[_c('a',{attrs:{"href":content.linkURL}},[_vm._v(" "+_vm._s(content.linkName)+" ")]),_vm._v(" → ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }